/**
 * Locale keys shared across routing, Link, and message bundles in `./index`.
 * Import this module instead of `./index` when you only need locale lists — avoids
 * pulling the full translation tables into lazy-loaded chunks (e.g. FilterModal).
 */
export const supportedLocales = ['en', 'fi', 'sv'] as const;

export type AppLocale = (typeof supportedLocales)[number];

export const defaultLocale: AppLocale = 'en';
